import React from 'react';

const Card = ({ icon: Icon, header, text }) => {
    return (
        <div className='group text-sm sm:text-base m-4 cursor-default min-h-72 flex flex-col justify-center items-center relative duration-500 rounded-2xl overflow-hidden'>
            <div className='absolute inset-0 bg-gradient-to-br from-white/[0.06] to-white/[0.02] backdrop-blur-md border border-white/10 rounded-2xl transition-all duration-500 group-hover:border-orange-500/40 group-hover:shadow-[0_0_30px_rgba(196,66,0,0.15)]'></div>
            <div className='absolute inset-0 bg-gradient-to-br from-orange-600/0 to-orange-500/0 group-hover:from-orange-600/10 group-hover:to-orange-500/5 rounded-2xl transition-all duration-500'></div>

            <div className='relative z-10 p-8 flex flex-col items-center transition-transform duration-500 ease-in-out group-hover:-translate-y-3'>
                <div className='w-16 h-16 rounded-xl bg-gradient-to-br from-orange-600/20 to-orange-400/10 flex items-center justify-center mb-5 transition-all duration-500 group-hover:scale-110 group-hover:from-orange-600/30 group-hover:to-orange-400/20 group-hover:shadow-[0_0_20px_rgba(196,66,0,0.2)]'>
                    <Icon size={32} className="text-orange-400 transition-colors duration-500 group-hover:text-orange-300" />
                </div>
                <h1 className='gold-text font-bold text-xl text-center mb-3'>{header}</h1>
            </div>

            <div className='relative z-10 px-6 pb-6 opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-40 transition-all duration-500 ease-in-out overflow-hidden'>
                <p dir='rtl' className='text-gray-300 text-center text-sm leading-relaxed'>{text}</p>
            </div>
        </div>
    );
}

export default Card;
